import get from 'lodash/get';

export const getApplicationId = state => get(state, 'application.applicationDetail.id');
